export const SAVE_BUTTON_LABEL = 'Продолжить';
export const CANCEL_BUTTON_LABEL = 'Отменить';
